// import styles from "./GalleryHeader.module.scss";
// import galStyles from "../Gallery/Gallery.module.scss";
import React from "react";
import { fit } from "../../utils";

export interface GalleryHeaderProps {
    is_host: boolean;
    avatar: string;
    display_name: string;
    shareRight: number;
    onFB?: () => void;
    onTwitter?: () => void;
    onPinterest?: () => void;
    onMail?: () => void;
    onShare: () => void;
}

export const GalleryHeader = (props: GalleryHeaderProps) => {
    
    return (
        <header className="board-header board-header--browse">
            <div className="board-header-bg"></div>

            <div className="board-header-pic board-header-pic--browse">
                <img src={props.avatar} className="board-header-pic-img board-header-pic-img--browse" />
            </div>

            <div ref={fit} className="board-header-name board-header-name--browse">{props.display_name}</div>

            {props.is_host && (
                <div className="board-share-container">
                    <p onClick={props.onShare}>Share</p>

                </div>)
            }
        </header>
    );
}

export default GalleryHeader
